import { Spinner } from '@chakra-ui/react'
import type React from 'react'
import DefaultModal from '../../../../../../components/DefaultModal'

interface ConfirmDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  confirmLabel: string
  isLoading?: boolean
  isConfirmDisabled?: boolean
  children: React.ReactNode
}

// A small confirmation dialog on top of the shared DefaultModal — reused for the WM admin actions that
// need an explicit acknowledgement (Invite, Mark agreement signed, Remind a whole book). The body copy is
// passed in by the caller so each action can state exactly what it does and whether it is reversible.
const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  confirmLabel,
  isLoading = false,
  isConfirmDisabled = false,
  children,
}) => (
  <DefaultModal
    isOpen={isOpen}
    onClose={onClose}
    isLoading={false}
    title={title}
    whiteBG
    maxW="520px"
  >
    <div className="p-5 pt-0 space-y-5">
      <div className="text-sm color-text-description space-y-3">{children}</div>
      <div className="flex gap-3 pt-2">
        <button
          className="button-secondary flex-1"
          type="button"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          className="button flex-1"
          type="button"
          disabled={isLoading || isConfirmDisabled}
          onClick={onConfirm}
        >
          {isLoading ? <Spinner size="sm" /> : confirmLabel}
        </button>
      </div>
    </div>
  </DefaultModal>
)

export default ConfirmDialog
